import React, { useEffect, useContext } from "react";
import AuthContext from "../../context/auth/authContext";
const SocialAuth = ({ match, history }) => {
  const { userData, getUser, setToken, token } = useContext(AuthContext);
  useEffect(() => {
    if (userData) {
      history.push("/");
    } else {
      let str = /^[A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*$/;
      if (str.test(match.params.token)) {
        localStorage.setItem("token", JSON.stringify(match.params.token));
        setToken(match.params.token);
      }
    }
    if (token) {
      getUser();
    }

    //eslint-disable-next-line
  }, [userData, token]);
  return <div></div>;
};

export default SocialAuth;
